import FieldPermissionUpdate from './FieldPermissionUpdate'
export {FieldPermissionUpdate}
export default FieldPermissionUpdate
